'use es6';

import { createSelector } from 'reselect';
import { StateKeys } from 'FormsUI/constants/Dashboard';
const getDashboard = state => state.dashboard;
export const getForms = createSelector(getDashboard, dashboard => dashboard[StateKeys.ALL_FORMS]);
export const getAnalyticsDateRange = createSelector(getDashboard, dashboard => dashboard[StateKeys.FORM_ANALYTICS_DATE_RANGE]);
export const getAnalyticsSelectedForms = createSelector(getDashboard, dashboard => dashboard[StateKeys.FORM_ANALYTICS_SELECTED_FORMS]);
export const getAnalyticsSearchQuery = createSelector(getDashboard, dashboard => dashboard[StateKeys.FORM_ANALYTICS_SEARCH_QUERY]);
export const getAnalyticsBusinessUnitId = createSelector(getDashboard, dashboard => dashboard[StateKeys.FORM_ANALYTICS_BUSINESS_UNIT_ID]);